import { BundledSettingsProvider } from '../configuration/bundledSettingsProvider';
import type { DamMediaContract } from './damMediaContract';
import type { IMediaDownloadUrlResolver } from './IMediaDownloadUrlResolver';
import { EntityRendition } from '../dam-api-client/DiscoveryDAMApiTypes';
import type { TransformOptions } from '../utils/imageTransform';

export class DamMediaDownloadUrlResolver implements IMediaDownloadUrlResolver {

    private readonly staticDomain: (external?: string) => string;

    public constructor() {
        this.staticDomain = (ext?: string) => BundledSettingsProvider.newInstance().getSettingSync<any>(`dam${ext ? `/${ext}` : ''}/staticDomain`);
    }

    public resolve(media: DamMediaContract, options?: TransformOptions): string {
        let permalink = media.permalink;
        if (media.type === 'Document' || media.type === 'Slideshow') { // use proxy to open in browser
            const proxyUrl = media.variants?.find(v => v.type === EntityRendition.Proxy)?.downloadUrl;
            if (proxyUrl) {
                permalink = proxyUrl;
            }
        } else if (media.type === 'Binary') {
            const proxyUrl = media.variants?.find(v => v.type === EntityRendition.Essence)?.downloadUrl; // friendly url on Essence
            if (proxyUrl) {
                permalink = proxyUrl;
            }
        } else if (options?.rendition) {
            const url = media.variants?.find(v => v.type === options.rendition)?.downloadUrl;
            if (url) {
                permalink = url;
            }
        }
        if (permalink.startsWith('/contents/')) { // use relative urls for friendly-urls
            return permalink; // without params
        } else {
            return `https://${this.staticDomain(media.external)}${permalink}`; // without params
        }
    }
}